import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["offerId", "quantity", "imageUrl", "title", "children", "sourceId", "sourceType", "sourcePosition", "eventId", "refetchQueries", "awaitRefetchQueries", "noToast", "searchTrackingToken", "onClick", "isFormValid", "getValues", "setError", "setLoading"];
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { useCallback, useContext } from "react";
import { emitAddToCart, getSourcePlatform } from "@catchoftheday/analytics";
import { Button } from "@catchoftheday/cg-components";
import { CustomerContext } from "@catchoftheday/customer";
import { MutationType, useToast } from "../../hooks";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var AddToCartButton = function AddToCartButton(_ref) {
  var _props$variant;

  var offerId = _ref.offerId,
      quantity = _ref.quantity,
      imageUrl = _ref.imageUrl,
      title = _ref.title,
      children = _ref.children,
      sourceId = _ref.sourceId,
      sourceType = _ref.sourceType,
      sourcePosition = _ref.sourcePosition,
      eventId = _ref.eventId,
      refetchQueries = _ref.refetchQueries,
      awaitRefetchQueries = _ref.awaitRefetchQueries,
      noToast = _ref.noToast,
      searchTrackingToken = _ref.searchTrackingToken,
      onClick = _ref.onClick,
      isFormValid = _ref.isFormValid,
      getValues = _ref.getValues,
      setError = _ref.setError,
      _setLoading = _ref.setLoading,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useContext = useContext(CustomerContext),
      customer = _useContext.data;

  var addToCart = useToast({
    mutationType: MutationType.ADD_TO_CART,
    setError: setError,
    setLoading: function setLoading(loading) {
      _setLoading === null || _setLoading === void 0 ? void 0 : _setLoading(loading);
    },
    noToast: noToast,
    onCompleted: onClick,
    refetchQueries: refetchQueries,
    awaitRefetchQueries: awaitRefetchQueries
  });
  var onAddToCart = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(personalisedValues) {
      var _yield$addToCart, status;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return addToCart({
                imageUrl: imageUrl,
                title: title
              }, {
                eventId: eventId,
                offerId: offerId,
                quantity: quantity,
                sourcePlatform: getSourcePlatform(),
                sourceId: sourceId,
                sourceType: sourceType === null || sourceType === void 0 ? void 0 : sourceType.toString(),
                sourcePosition: sourcePosition,
                personalisedValues: personalisedValues
              }, searchTrackingToken ? {
                headers: {
                  // Replace or append `cart` event id to the search tracking token
                  srtrev: "".concat(searchTrackingToken === null || searchTrackingToken === void 0 ? void 0 : searchTrackingToken.split(".")[0], ".cart")
                }
              } : {});

            case 2:
              _yield$addToCart = _context.sent;
              status = _yield$addToCart.status;

              if (status !== "ServerError") {
                emitAddToCart({
                  customer_id: customer === null || customer === void 0 ? void 0 : customer.id,
                  success: status == "OK",
                  source_id: sourceId,
                  source_type: sourceType,
                  source_position: sourcePosition,
                  offer_id: offerId,
                  event_id: eventId
                });
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [addToCart, imageUrl, title, offerId, quantity, customer === null || customer === void 0 ? void 0 : customer.id, sourceId, sourceType, sourcePosition, eventId, searchTrackingToken]);
  var onAddPersonalisedProductToCart = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var formData, personalisedValues;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.t1 = typeof isFormValid == "function";

            if (!_context2.t1) {
              _context2.next = 5;
              break;
            }

            _context2.next = 4;
            return isFormValid();

          case 4:
            _context2.t1 = !_context2.sent;

          case 5:
            _context2.t0 = _context2.t1;

            if (_context2.t0) {
              _context2.next = 8;
              break;
            }

            _context2.t0 = !getValues;

          case 8:
            if (!_context2.t0) {
              _context2.next = 10;
              break;
            }

            return _context2.abrupt("return");

          case 10:
            formData = getValues();
            personalisedValues = Object.keys(formData).map(function (key) {
              return {
                name: key,
                value: "".concat(formData[key])
              };
            });
            onAddToCart(personalisedValues);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [onAddToCart, isFormValid, getValues]);
  return ___EmotionJSX(Button, _extends({
    variant: (_props$variant = props.variant) !== null && _props$variant !== void 0 ? _props$variant : "plain",
    sizeVariant: "sm",
    p: 0,
    onClick: function onClick() {
      props.type == "submit" ? onAddPersonalisedProductToCart() : onAddToCart();
    },
    "aria-label": "Add to cart",
    color: "secondary",
    textTransform: "initial",
    fontSize: {
      xs: "xs",
      md: "base"
    },
    fontWeight: "normal",
    underlineOnHover: true
  }, props), children);
};